import React from "react";
import { Form, Input, Button, Card, notification } from "antd";
import { AuthService } from "../../services/AuthService";

const ChangePassword = () => {
    const [form] = Form.useForm();

    const onFinish = async (values: any) => {
        const res = await AuthService.changePassword({
            old_password: values.old_password,
            new_password: values.new_password
        });
        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            form.resetFields();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    return (
        <Card
            style={{
                maxWidth: 800
            }}
        >
            <Form
                form={form}

                name="change-password"
                initialValues={{
                    old_password: '',
                    new_password: '',
                    confirm_new_password: '',
                }}
                onFinish={onFinish}
                layout="vertical"
            >
                <Form.Item
                    label="Old Password"
                    name="old_password"
                    rules={[{ required: true, message: "Please enter your old password!" }]}
                >
                    <Input.Password placeholder="Enter old password" />
                </Form.Item>

                <Form.Item
                    label="New Password"
                    name="new_password"
                    rules={
                        [
                            { required: true, message: "Please enter your new password!" },
                            { min: 6, message: "Password must be at least 6 characters!" }
                        ]
                    }
                >
                    <Input.Password placeholder="Enter new password" />
                </Form.Item>

                <Form.Item
                    label="Confirm New Password"
                    name="confirm_new_password"
                    dependencies={["new_password"]}
                    rules={[
                        { required: true, message: "Please confirm your new password!" },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("new_password") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error("Passwords do not match!"));
                            },
                        }),
                    ]}
                >
                    <Input.Password placeholder="Confirm new password" />
                </Form.Item >

                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Change Password
                    </Button>
                </Form.Item>
            </Form >
        </Card>
    );
};

export default ChangePassword;
